import apiClient from './api';
import type {
  SaveTranslationPayload,
  AutoTranslatePayload,
  ApiResponse,
} from '../types/api.types';

export const translationsService = {
  // Save/update manual translation
  async saveTranslation(payload: SaveTranslationPayload): Promise<ApiResponse> {
    const response = await apiClient.post<ApiResponse>('/save/translation', payload);
    return response.data;
  },

  // Request auto-translation
  async autoTranslate(payload: AutoTranslatePayload): Promise<ApiResponse> {
    const response = await apiClient.post<ApiResponse>('/auto/translateAuto', payload);
    return response.data;
  },
};
